import alertStyles from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import formStyles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import selectStyles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import RadioStyles from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.js";
import TooltipStyles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";

import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { infoColor, whiteColor } from "assets/jss/material-dashboard-pro-react";
import typoStyles from "assets/jss/material-dashboard-pro-react/components/typographyStyle.js";

const cellContent = {
  backgroundColor: 'white',
  overflowY: 'auto',
  padding: '10px',
  borderRight: '1px solid ' + infoColor[0],
}

const styles = {
  ...alertStyles,
  ...formStyles,
  ...selectStyles,
  ...RadioStyles,
  ...TooltipStyles,
  ...typoStyles,
  right: {
    float: "right"
  },
  left: {
    float: "left"
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
  maxHeightCard: {
    height: 'calc(100% - 60px)'
  },
  cardVertical: {
    marginTop: "0",
  },
  cardTitle: {
    marginTop: "0",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  },
  createScenario: {
    height: '85%',
    width: '100%',
    display: 'flex',
    border: '1px dashed ' + infoColor[0]
  },
  dropzone: {
    height: '100%',
    width: '100%',
    display: 'flex',
    border: '1px dashed ' + infoColor[0]
  },
  dropzoneText: {
    margin: 'auto',
    textAlign: 'center',
    padding:'20px',
    '& > div': { marginBottom: '10px' },
  },
  cardHeader: {
    backgroundColor: infoColor[0],
    color: whiteColor,
    padding: '0 1.25rem',
    '& > h4': { marginTop: '12px' }
  },
  underChartIcons: { fill: 'white' },
  cellTitle: {
    padding: '5px 20px', backgroundColor: infoColor[0], color: 'white',
    borderRight: '1px solid white',
    '& > button': { marginTop: '0px' },
  },
  cellContent: {
    ...cellContent
  },
  cellContentProject: {
    ...cellContent, 
    height: "calc(50vh - 100px)",
  },
  cellContentAps: {
    ...cellContent, 
    height: "calc(100vh - 150px)",
  },
  cellContentModel: {
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: '10px',
  },
  collapsed: { padding: '0px !important' },
  inputLabelCell: { textAlign: 'right', paddingTop: '32px !important' },
  sectionTitle: {
    textAlign: 'center', padding: '15px', backgroundColor: infoColor[0], color: whiteColor, fontSize: '1.3em',
    fontWeight: 'bold', margin: '20px 0px 10px 0px'
  },

  modalTitle: { color: infoColor[0], fontWeight: 'bold' },
  modalHeader: { borderBottom: '2px solid ' + infoColor[0] },
};

export default styles;